module.exports = __webpack_public_path__ + "img/arrow-down.434779f5.svg";